import { TabViewModel } from './tab/tabviewmodel';

export interface GenericTabViewModel
{
    getHeaderTitle(): string;
    getTab(title: string): TabViewModel | undefined;
    removeAllTabs(): void;
    getSelectedTabTitle(): string;
    addTab(tab: TabViewModel): void;
    getListOfTitles(): string[];
}

export class GenericTabViewModelImpl implements GenericTabViewModel
{
    private listOfTitles: string[];
    private tabViewModelsMap: Map<string, TabViewModel>;
    private selectedTabTitle: string;

    constructor()
    {
        this.listOfTitles = [];
        this.tabViewModelsMap = new Map<string, TabViewModel>();
    }

    getHeaderTitle(): string 
    {
        throw new Error("Method not implemented.");
    }    

    getTab(title: string): TabViewModel | undefined
    {
        this.setSelectedTabTitle(title);
        return this.tabViewModelsMap.get(title);
    }

    removeAllTabs(): void {
        this.listOfTitles.length = 0;

        this.tabViewModelsMap.clear();
    }

    getSelectedTabTitle(): string {
        return this.selectedTabTitle;
    }

    getListOfTitles(): string[] {
        return this.listOfTitles;
    }

    addTab(tab: TabViewModel): void 
    {
        this.listOfTitles.push(tab.getTitle());
        this.tabViewModelsMap.set(tab.getTitle(), tab);
    }

    private setSelectedTabTitle(title: string): void
    {
        this.selectedTabTitle = title;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/tabs/generictabviewmodel.ts